import React, {useContext, useEffect} from "react";
import $ from "jquery";
import BackofficeContext from "../../../context/BackofficeContext";
import "../../../css/page/ErrorMessage.css";

const ErrorMessage = props => {
    const { setErrorText } = useContext(BackofficeContext);

    const cleanError = () => {
        $(".backoffice > .errorMessage").addClass("disappear");

        setTimeout(() => {
            setErrorText(null);
        }, 500);
    }

    useEffect(() => {
        let timeout = setTimeout(() => { cleanError() }, 4000);

        return() => {
            clearTimeout(timeout);
        }
    }, []);

    return (
        <p className={"errorMessage"}>
            {
                props.message
            }
        </p>
    )
}

export default ErrorMessage;